import React, { Fragment } from "react";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import { MainTitle, SubTitle,NapaVersion } from "../styled/Title.styled";
import { Link } from "react-router-dom";

export default function Title({ emboss, nonLink,napaVersion}) {
  return (
    <Fragment>
      <Grid container spacing={0} justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          {!emboss && !nonLink && (
              <Link to="/home">
                <div style={{display:"flex", alignItems: "center", justifyContent: "start",}}>
               <MainTitle emboss={emboss}>NaPA </MainTitle>
               <NapaVersion> 2.0</NapaVersion>
               </div>
            </Link>
          )}
          {napaVersion && (
            <div style={{display:"flex", alignItems: "center", justifyContent: "center",}}>
            <MainTitle emboss={emboss}>NaPA </MainTitle>
              <NapaVersion> 2.0</NapaVersion>
              </div>
          )}
          {emboss && (
            <MainTitle emboss={emboss} style={{ fontSize: "28px" }}>
              {" "}
              Network & Planning Analytics
            </MainTitle>
          )}
        </Grid>
        <Grid item xs={12}>
          {emboss ? (
            <>
              {" "}
              <SubTitle emboss={emboss}>Geospatial Application</SubTitle>
            </>
          ) : (
            <>
              {!nonLink && (
                <Link to="/home">
                  <SubTitle emboss={emboss}>Geospatial Application</SubTitle>
                </Link>
              )}
              {nonLink && (
                <SubTitle emboss={emboss}>Geospatial Application</SubTitle>
              )}
            </>
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
}

Title.propTypes = {
  mainTitleColor: PropTypes.oneOf(["#006F35", "#FFFF"]),
  subTitleColor: PropTypes.oneOf(["#006F35", "#FFFF"]),
};

Title.defaultPops = {
  mainTitleColor: "#006F35",
  subTitleColor: "#FFFF",
};
